import axios from 'axios';

import { CompanyRole } from '../enums/company-role.enum';
import { CompanyTeamDto, InviteMemberDto, PendingInviteDto, RemoveMemberDto } from '../interfaces/team.dto';

class TeamService {
  /** Every active seat of the company, by name, and for admins the invites still pending */
  async getTeam(): Promise<CompanyTeamDto> {
    return (await axios.get<CompanyTeamDto>('company/team')).data;
  }

  async invite(dto: InviteMemberDto): Promise<PendingInviteDto> {
    return (await axios.post<PendingInviteDto>('company/invites', dto)).data;
  }

  /** Emails a fresh link; the one sent before stops working */
  async resendInvite(inviteId: string): Promise<PendingInviteDto> {
    return (await axios.post<PendingInviteDto>(`company/invites/${inviteId}/resend`)).data;
  }

  async revokeInvite(inviteId: string): Promise<void> {
    await axios.delete(`company/invites/${inviteId}`);
  }

  async changeMemberRole(investorId: string, role: CompanyRole): Promise<void> {
    await axios.patch(`company/members/${investorId}`, { role });
  }

  /** Adds a seat as a collaborator on portfolios: their units now and every unit filed in later */
  async addToPortfolios(investorId: string, portfolioIds: string[]): Promise<void> {
    await axios.post(`company/members/${investorId}/portfolios`, { portfolioIds });
  }

  async removeMember(investorId: string, dto: RemoveMemberDto): Promise<void> {
    await axios.delete(`company/members/${investorId}`, { data: dto });
  }
}

export default new TeamService();
